import React, { Component } from "react";
import {
    FiActivity,
    FiCloud,
    FiDatabase,
    FiGitBranch,
    FiShield,
    FiUsers,
} from "react-icons/fi";

const ServiceList = [
    {
        icon: <FiDatabase />,
        title: "Enterprise GenAI Platforms (RAG + Knowledge)",
        description:
            "I design retrieval systems that ground LLMs on enterprise data—chunking/metadata, hybrid search, re-ranking, citations, and permission-aware access—so answers are trustworthy, explainable, and production-ready.",
        chips: ["RAG pipelines", "Vector DB patterns", "Citation/grounding", "Access controls"],
    },
    {
        icon: <FiGitBranch />,
        title: "Agent Orchestration & Workflow Automation",
        description:
            "I build agentic workflows that do real work: tool orchestration, state management, approvals (HITL), retries/timeouts, and safe-by-default actions—so automation scales without breaking trust or controls.",
        chips: ["Tool registry", "Workflow state", "HITL approvals", "Safe actions"],
    },
    {
        icon: <FiActivity />,
        title: "LLMOps: Evaluation, Observability & Reliability",
        description:
            "I operationalize LLM quality like software: automated eval suites, regression gating, telemetry (cost/latency/quality), prompt/version management, and rollbacks—so teams can iterate fast without surprises in production.",
        chips: ["Evals as CI", "Tracing/metrics", "Cost controls", "Rollback strategy"],
    },
    {
        icon: <FiShield />,
        title: "Security, Governance & Regulated Delivery",
        description:
            "I ship AI under real compliance constraints: tenant isolation, RBAC, audit logs, data retention boundaries, redaction, and policy enforcement—so leaders can approve deployment with confidence in regulated environments.",
        chips: ["RBAC", "Audit logs", "Data boundaries", "Policy enforcement"],
    },
    {
        icon: <FiCloud />,
        title: "Cloud & Enterprise Integration (AWS / Azure / GCP)",
        description:
            "I architect AI platforms to fit the enterprise: APIs, event-driven workflows, secure networking, secrets, and integration with existing systems—delivered on AWS, Azure, GCP, and private cloud based on constraints.",
        chips: ["API-first", "Event-driven", "Private connectivity", "Secrets/IAM"],
    },
    {
        icon: <FiUsers />,
        title: "Forward-Deployed Delivery & Adoption",
        description:
            "I lead customer and cross-org engagements end-to-end—discover, design, implement, and enable—turning ambiguous problems into shipped systems, aligned stakeholders, and measurable outcomes that teams actually adopt.",
        chips: ["CTO alignment", "Enablement", "Rollout playbooks", "Adoption metrics"],
    },
]

class ServiceThree extends Component{
    render(){
        const { column } = this.props;
        const ServiceContent = ServiceList.slice(0, this.props.item);
        
        return(
            <React.Fragment>
                <div className="row">
                    {ServiceContent.map( (val , i) => (
                        <div className={`${column}`} key={i}>
                            <div className="service service__style--2 service-specialty-card">
                                <div className="icon" aria-hidden="true">{val.icon}</div>
                                <div className="content">
                                    <h3 className="title">{val.title}</h3>
                                    <p>{val.description}</p>
                                    {Array.isArray(val.chips) && val.chips.length > 0 ? (
                                        <ul className="specialty-chips">
                                            {val.chips.map((chip) => (
                                                <li key={chip}>
                                                    <span className="chip">{chip}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </React.Fragment>
        )
    }
}


export default ServiceThree;
